import React from "react";

export default function Header() {
  return (
    <header className="header">
      <div className="wrap header-inner">
        <a className="brand" href="#top" aria-label="JKM Coastal Carpentry & Construction home">
          <img
            className="brand-logo"
            src="/logo.png?v=2"
            alt="JKM Coastal Carpentry & Construction"
            width="340"
            height="112"
          />
          <span className="brand-place">Wells, ME &bull; Portland &rarr; Portsmouth</span>
        </a>
        <nav className="nav" aria-label="Main navigation">
          <a href="#services">Services</a>
          <a href="#about">Meet Jason</a>
          <a className="optional" href="#builders">For builders</a>
          <a className="optional" href="#process">How it works</a>
          <a className="btn" href="#contact">
            Project inquiry <span aria-hidden="true">&rarr;</span>
          </a>
        </nav>
      </div>
    </header>
  );
}
